import { useState, useEffect } from 'react';
import { axiosApi } from '../../api/setupApi';

let pendingUsersRequest = null;

const useGetAllUser = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsers = async () => {
    if (pendingUsersRequest) {
      return pendingUsersRequest;
    }

    setIsLoading(true);
    setError(null);

    pendingUsersRequest = axiosApi.get('/auth/getAll_users');

    try {
      const { data } = await pendingUsersRequest;
      setUsers(data);
      return data;
    } catch (err) {
      const message = err.response?.data?.message || err.message || 'Failed to load users';
      console.error('Error in useGetAllUsers:', message);
      setError(message);
      throw err;
    } finally {
      pendingUsersRequest = null;
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return { users, isLoading, error, refetch: fetchUsers };
};

export default useGetAllUser;
